// React Dependendecies
import React from "react";
import { useState } from "react";
import { Link, Routes, Route } from "react-router-dom";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";

// Components
import useFetch from "../useFetch";

const Footer = () => {

  const { isLoading, error, data } = useFetch(`${process.env.REACT_APP_BACKEND}/api/footer`)

  let year = new Date().getFullYear()
  let footer = null;

  const url = 'https://api.cc.email/v3/contacts/sign_up_form';
  const accessToken = '{access_token}';

  const formData = {
    email_address: 'dlang@example.com',
    list_memberships: [
      'efb072f0-541d-11e3-9c4e-d4ae52754007'
    ]
  };

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    },
    body: JSON.stringify(data)
  };

  // fetch(url, options)
  //   .then(response => {
  //     if (!response.ok) {
  //       throw new Error('Network response was not ok');
  //     }
  //     return response.json();
  //   })
  //   .then(data => {
  //     console.log(data);
  //   })
  //   .catch(error => {
  //     console.error('There was a problem with your fetch operation:', error);
  //   });

  if (data) {

    footer = data.data.attributes;

    return (
        <>
            <div className="green-bar"></div>
            <div className="footer-container"> 
                <div className="socials-container">
                    <a href={footer.Donate_Link} target="_blank">
                        <h3>Donate</h3>
                    </a>
                    <a href={footer.Instagram_Link} target="_blank">
                        <h3>Instagram</h3>
                    </a>
                    <a href={footer.Facebook_Link} target="_blank">
                        <h3>Facebook</h3>
                    </a> 
                </div>
                <div className="mailing-list-container">
                {/* <!-- Begin Constant Contact Inline Form Code --> */}
                <div class="ctct-inline-form" data-form-id="b54bbde4-3af9-48b5-ac5b-f7516d80e582">
                    
                </div>
                {/* <!-- End Constant Contact Inline Form Code --> */}
                    <h3>Join Our Mailing List</h3>
                    <div className="mailing-list-input">
                        <div className="input-field">
                            <label>Your Email</label>
                        </div>
                        <button id="mailchimp-footer-subscribe">Go</button>
                    </div>
                </div>
                <div className="IP-container">
                    <BlocksRenderer className="contact-info-rich-text" content={footer.Contact_Info_Rich_Text}/>                </div>
            </div>
            <div className="logo-bar">
              <div className="bebe-miller-logo-container-footer">
                        <svg id="bmc-logo-large-footer" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 295.3 284">
                            <defs>
                                <style>
                                .cls-1 {`
                                    fill: #fff;
                                    `
                                }
                                </style>
                            </defs>
                            <g id="Layer_1-2" data-name="Layer 1">
                                <g>
                                <g>
                                    <path class="cls-1" d="m26.8,251.89l10.34,3.12c-.69,2.89-1.79,5.31-3.28,7.25-1.49,1.94-3.35,3.41-5.56,4.39-2.21.99-5.03,1.48-8.45,1.48-4.15,0-7.54-.6-10.17-1.81-2.63-1.2-4.9-3.32-6.81-6.35-1.91-3.03-2.87-6.91-2.87-11.64,0-6.31,1.68-11.15,5.04-14.54,3.36-3.39,8.11-5.08,14.26-5.08,4.81,0,8.59.97,11.34,2.91,2.75,1.94,4.8,4.92,6.13,8.94l-10.42,2.31c-.36-1.16-.75-2.01-1.15-2.55-.66-.9-1.47-1.59-2.42-2.08s-2.02-.73-3.2-.73c-2.67,0-4.72,1.07-6.15,3.22-1.08,1.59-1.62,4.1-1.62,7.51,0,4.22.64,7.12,1.93,8.69,1.29,1.57,3.09,2.35,5.42,2.35s3.96-.63,5.12-1.9c1.15-1.27,1.99-3.1,2.51-5.51Z"/>
                                    <path class="cls-1" d="m41.39,248.46c0-6.22,1.74-11.07,5.21-14.54,3.47-3.47,8.31-5.2,14.51-5.2s11.25,1.7,14.69,5.11c3.44,3.41,5.16,8.18,5.16,14.31,0,4.45-.75,8.11-2.25,10.96-1.5,2.85-3.67,5.07-6.51,6.66-2.84,1.59-6.38,2.38-10.62,2.38s-7.87-.68-10.69-2.05c-2.82-1.37-5.11-3.54-6.86-6.5-1.75-2.96-2.63-6.67-2.63-11.13Zm11.8.05c0,3.85.72,6.61,2.15,8.29,1.43,1.68,3.38,2.52,5.85,2.52s4.5-.82,5.89-2.47c1.39-1.65,2.08-4.6,2.08-8.87,0-3.59-.73-6.21-2.17-7.86-1.45-1.66-3.42-2.48-5.9-2.48s-4.29.84-5.73,2.52-2.16,4.46-2.16,8.35Z"/>
                                    <path class="cls-1" d="m87.19,229.38h15.52l5.98,23.19,5.94-23.19h15.51v38.12h-9.66v-29.07l-7.45,29.07h-8.75l-7.43-29.07v29.07h-9.66v-38.12Z"/>
                                    <path class="cls-1" d="m137.62,229.38h19.62c4.27,0,7.47,1.01,9.6,3.04,2.13,2.03,3.19,4.91,3.19,8.66s-1.16,6.85-3.48,9.02c-2.32,2.17-5.86,3.25-10.61,3.25h-6.46v14.14h-11.85v-38.12Zm11.85,16.25h2.89c2.27,0,3.87-.39,4.79-1.18.92-.79,1.38-1.8,1.38-3.03s-.4-2.21-1.2-3.04-2.3-1.25-4.51-1.25h-3.36v8.5Z"/>
                                    <path class="cls-1" d="m195.14,261.2h-13.4l-1.86,6.29h-12.05l14.35-38.12h12.87l14.35,38.12h-12.36l-1.91-6.29Zm-2.45-8.24l-4.21-13.7-4.17,13.7h8.39Z"/>
                                    <path class="cls-1" d="m213.24,229.38h11.02l14.38,21.09v-21.09h11.12v38.12h-11.12l-14.3-20.93v20.93h-11.1v-38.12Z"/>
                                    <path class="cls-1" d="m253.75,229.38h13.11l7.69,12.86,7.71-12.86h13.04l-14.85,22.15v15.96h-11.83v-15.96l-14.87-22.15Z"/>
                                </g>
                                <g>
                                    <path class="cls-1" d="m0,93.59h20.96l8.08,79.53,8.02-79.53h20.95v130.7h-13.05v-99.68l-10.06,99.68h-11.81l-10.04-99.68v99.68H0V93.59Z"/>
                                    <path class="cls-1" d="m68.81,93.59h15.97v130.7h-15.97V93.59Z"/>
                                    <path class="cls-1" d="m96.22,93.59h15.94v98.52h24.87v32.19h-40.81V93.59Z"/>
                                    <path class="cls-1" d="m144.27,93.59h15.94v98.52h24.87v32.19h-40.81V93.59Z"/>
                                    <path class="cls-1" d="m192.29,93.59h42.71v27.9h-26.74v20.78h24.8v26.66h-24.8v25.77h27.51v29.6h-43.48V93.59Z"/>
                                    <path class="cls-1" d="m244.57,224.3V93.59h26.56c4.93,0,8.69,1.07,11.29,3.21,2.6,2.14,4.7,6.11,6.3,11.9,1.59,5.79,2.39,12.85,2.39,21.17,0,7.25-.61,13.51-1.83,18.77-1.22,5.26-2.9,9.52-5.03,12.79-1.36,2.08-3.23,3.8-5.6,5.17,1.9,1.61,3.28,3.21,4.15,4.82.59,1.07,1.44,3.36,2.55,6.88,1.11,3.51,1.86,6.22,2.23,8.12l7.72,37.87h-18.01l-8.52-39.94c-1.08-5.17-2.04-8.53-2.88-10.08-1.15-2.02-2.45-3.03-3.9-3.03h-1.41v53.05h-16.01Zm16.01-77.75h6.72c.73,0,2.13-.59,4.22-1.78,1.06-.53,1.92-1.9,2.59-4.1.67-2.2,1-4.73,1-7.58,0-4.22-.53-7.46-1.58-9.72s-3.04-3.39-5.95-3.39h-7v26.57Z"/>
                                </g>
                                <path class="cls-1" d="m0,16.38h42.27c7.05,0,12.45,1.74,16.23,5.21,3.77,3.47,5.66,7.78,5.66,12.91,0,4.3-1.35,7.99-4.04,11.07-1.79,2.05-4.42,3.67-7.88,4.86,5.25,1.26,9.11,3.42,11.59,6.48,2.48,3.06,3.71,6.91,3.71,11.54,0,3.77-.88,7.17-2.64,10.18-1.76,3.01-4.17,5.39-7.23,7.15-1.89,1.09-4.75,1.89-8.57,2.38-5.08.66-8.46.99-10.12.99H0V16.38Zm22.78,28.54h9.82c3.52,0,5.97-.6,7.35-1.81,1.38-1.21,2.07-2.95,2.07-5.24,0-2.12-.69-3.77-2.07-4.96-1.38-1.19-3.78-1.79-7.2-1.79h-9.97v13.8Zm0,28.59h11.52c3.89,0,6.63-.69,8.23-2.06,1.6-1.37,2.39-3.22,2.39-5.53,0-2.15-.79-3.88-2.37-5.19-1.58-1.31-4.35-1.96-8.3-1.96h-11.47v14.74Z"/>
                                <path class="cls-1" d="m153.96,16.38h42.27c7.05,0,12.45,1.74,16.23,5.21,3.77,3.47,5.66,7.78,5.66,12.91,0,4.3-1.35,7.99-4.04,11.07-1.79,2.05-4.42,3.67-7.88,4.86,5.25,1.26,9.11,3.42,11.59,6.48,2.48,3.06,3.71,6.91,3.71,11.54,0,3.77-.88,7.17-2.64,10.18-1.76,3.01-4.17,5.39-7.23,7.15-1.89,1.09-4.75,1.89-8.57,2.38-5.08.66-8.46.99-10.12.99h-38.98V16.38Zm22.78,28.54h9.82c3.52,0,5.97-.6,7.35-1.81,1.38-1.21,2.07-2.95,2.07-5.24,0-2.12-.69-3.77-2.07-4.96-1.38-1.19-3.78-1.79-7.2-1.79h-9.97v13.8Zm0,28.59h11.52c3.89,0,6.63-.69,8.23-2.06,1.6-1.37,2.39-3.22,2.39-5.53,0-2.15-.79-3.88-2.37-5.19-1.58-1.31-4.35-1.96-8.3-1.96h-11.47v14.74Z"/>
                                <polygon class="cls-1" points="233.68 16.38 295.3 16.14 295.3 32.27 256.31 31.92 256.31 43.49 291.46 43.49 291.46 58.33 256.31 58.33 256.31 72.67 295.3 72.67 295.3 89.15 233.68 89.15 233.68 16.38"/>
                                <polygon class="cls-1" points="80.34 15.75 141.95 15.5 141.95 31.64 102.97 31.29 102.97 42.85 138.11 42.85 138.11 57.7 102.97 57.7 102.97 72.04 141.95 72.04 141.95 88.52 80.34 88.52 80.34 15.75"/>
                                <rect class="cls-1" x="0" y="279.16" width="295.3" height="4.84"/>
                                <rect class="cls-1" x="0" y="0" width="295.3" height="4.84"/>
                                </g>
                            </g>
                        </svg>
                    </div>
                    <p><em>© Bebe Miller Company {year}</em></p>
                    <p><em>Designed and developed by <a target="_blank" href="http://www.failspacenyc.com/design-services">FAILSPACE</a></em></p>

            </div>
        </>

    )    
  }
}   

export default Footer;